import React from "react";
import { NavLink } from "react-router-dom";

export default function JobsPortal() {
  return (
    <section className="container page-top pt-10" style={{ paddingTop: "6rem" }}>
      <div className="container">
        {/* Title Section */}
        <div className="row mb-4">
          <div className="col-12 text-center">
            <h1 className="display-5 fw-bold text-primary">Jobs Portal – Where Talent Meets Opportunity</h1>
            <h5 className="text-muted">
              Connecting Employers and Job Seekers with Smart, Efficient Hiring Solutions
            </h5>
            <hr className="w-25 mx-auto" />
          </div>
        </div>

        {/* Image and Introduction */}
        <div className="row align-items-center mb-5">
          <div className="col-md-6">
            <img
              src="https://jobs.bytlas.com/images/howitworks.png"
              alt="Jobs Portal"
              className="img-fluid rounded shadow"
            />
          </div>
          <div className="col-md-6">
            <h2 className="fw-semibold">Why Choose Our Jobs Portal?</h2>
            <p>
              <strong>Bytlas Intelligence</strong> offers a comprehensive, user-friendly jobs portal that bridges the gap between talented professionals and forward-thinking employers.
              Our platform features advanced search, filtering, and AI-driven candidate-job matching.
            </p>
            <ul className="list-group list-group-flush">
              <li className="list-group-item">✅ AI-Powered Candidate Matching</li>
              <li className="list-group-item">✅ Resume and Profile Management</li>
              <li className="list-group-item">✅ Employer Dashboard with Analytics</li>
              <li className="list-group-item">✅ Secure Communication and Interview Scheduling</li>
            </ul>
          </div>
        </div>

        {/* Features Section */}
        <div className="row my-5">
          <div className="col-md-6">
            <h3 className="text-secondary">Empowering Job Seekers</h3>
            <p>
              Easily browse and apply to jobs that match your skills and preferences. Get personalized job recommendations and track your application status in real-time.
            </p>
          </div>

          <div className="col-md-6">
            <h3 className="text-secondary">Supporting Employers</h3>
            <p>
              Post jobs quickly, review applications efficiently, and leverage data-driven insights to hire the best talent faster. Our platform simplifies recruitment workflows end-to-end.
            </p>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-4">
          <NavLink to="/contact" className="btn btn-danger px-4 py-2 rounded-pill fw-bold">
            Contact Us to Get Started
          </NavLink>
        </div>
      </div>
    </section>
  );
}
